/**
 * Internal dependencies
 */
import { useIsMobile } from 'src/hooks/use-is-mobile';

import { CardGrid } from 'src/components/card/card-grid';
import Asset from 'src/components/card/Asset';

function SearchResultAssetsLayout({ onClick, showViewAll, children }) {
  const isMobile = useIsMobile();
  return (
    <div>
      <div className="relative flex text-gray-900 items-center justify-between">
        <div
          className={`text-base text-gray-500 font-semibold ${
            isMobile && 'pb-4'
          } pt-6 pl-4`}
        >
          Creations
        </div>
        {showViewAll && (
          <div
            className="text-sm font-medium pb-4 pt-6 pr-4 text-gray-700 cursor-pointer"
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onClick}
          >
            View all
          </div>
        )}
      </div>
      {children}
    </div>
  );
}

function SearchResultAssets({
  result,
  resultLimit = 4,
  openModal,
  isAllResult = false,
}) {
  const isMobile = useIsMobile();
  return (
    <CardGrid paddingTop={isMobile && !isAllResult ? '16px' : 0}>
      {result.slice(0, resultLimit).map((data, key) => {
        const mkey = `Search_Assets_${key}`;
        return (
          <Asset
            card
            key={mkey}
            className="mt-4 mb-2"
            author={data.author}
            result={data}
            imgURL={data.coverImgURL || ''}
            modalOpener={(e) => openModal(e)}
          />
        );
      })}
    </CardGrid>
  );
}

SearchResultAssets.Layout = SearchResultAssetsLayout;

export default SearchResultAssets;
